module.exports = __webpack_public_path__ + "static/media/3.b2912d99.jpg";